module.exports = __webpack_public_path__ + "img/charles_stor.17e720bf.png";